<template>
  <div class="auto-service" style="height:calc(100% - 60px)">
    <el-scrollbar class="w-full bg-white rounded shadow-theme h-full" wrap-class="overflow-x-hidden" ref="scrollRef">
      <div class="sub-words">自动估价是样本无指定配额时预估报价，详细报价请 
        <el-popover placement="top-start" trigger="hover">
          <div style="width: 200px; height: 200px">
            <img src="/assets/img/code/Mrs.Chai.png" class="w-full h-full" />
          </div>
          <span class="text-theme cursor-pointer" slot="reference">联系客服</span>
        </el-popover>
      </div>
      <header class="__card-title pl-5 pr-6 pt-1 text-medium-x text-black font-semibold">样本服务</header>
      <section class="px-6 box-border">
        <div class="flex">
          <label class="wj-calc-label">{{'问卷' | replaceText($route.query.scene, ['Vote','SignIn','Satisfaction','Appointment'].includes($route.query.scene)?1:0)}}题数</label>
          <div class="py-4 box-border flex-1 flex items-center justify-between">
            <div class="flex items-center">
              <div class="w-52 calc-slider">
                <el-slider :min="5" :max="300" v-model="wjQusNum"></el-slider>
              </div>
              <input-field-number
                class="ml-4 w-80px field-num-left"
                :min="5"
                :max="300"
                :precision="0"
                v-model="wjQusNum"
                size="small"
                controls-position="right"
                @blur="numberBlur"
              />
              <p class="ml-2 text-theme-black-250 text-medium leading-22 whitespace-nowrap">*矩阵题每个子题都为一个问题</p>
            </div>
            <div class="text-medium text-theme-black-450 text-right ml-6 mb-2 whitespace-nowrap font-semibold">
              ¥ {{ wjUnitPrice }}
            </div>
          </div>
        </div>
        <sample-service-check
          v-for="gk of checkGroupList"
          :key="gk.key"
          :label="gk.label"
          v-model="groupValues[gk.key]"
          :type="gk.type"
          :items="gk.list"
          :suffix="groupPrice[gk.key]"
        />
        <p class="w-full py-4 box-border text-small text-theme-black-250 leading-22 text-center">
          以上仅为样本部分属性，如需了解更多，请咨询客服
        </p>
        <div class="w-full py-7 box-border border-t border-solid border-border-gray flex justify-between">
          <figure class="flex flex-col justify-center items-center">
            <img class="w-32 h-32" src="/assets/img/code/Mrs.Chai.png" />
            <figcaption class="mt-1 text-small text-theme-black-850 leading-22">扫码获取完整报价</figcaption>
          </figure>
          <div class="flex-1 flex flex-col items-end">
            <div class="flex items-center mb-6">
              <div class="text-right whitespace-nowrap">
                <p class="text-medium text-theme-black-850 leading-22">预估样本单价</p>
                <p class="text-small text-theme-black-450 leading-22">
                  预估样本单价为无配额要求时报价，如需指定配额，请联系客服获取详细报价
                </p>
              </div>
              <div class="ml-7 text-large-x leading-22 text-danger font-semibold">¥ {{ samplePrice }}</div>
            </div>
            <div class="flex items-center justify-end">
              <p class="mr-6 text-medium text-theme-black-850 leading-22 font-semibold">需要样本数量</p>
              <div class="w-230px calc-slider">
                <el-slider :min="50" :max="10000000" v-model="sampleNum"></el-slider>
              </div>
              <input-field-number
                class="ml-4 w-110px field-num-left"
                :min="50"
                :max="10000000"
                :precision="0"
                v-model="sampleNum"
                size="small"
                controls-position="right"
              />
            </div>
            <div class="flex items-center mt-6">
              <div class="text-right whitespace-nowrap">
                <p class="text-medium text-theme-black-850 leading-22">本次预估报价</p>
                <p class="text-small text-theme-black-450 leading-22">仅为预估报价，实际报价请扫码咨询获取，还有更多优惠</p>
              </div>
              <div class="ml-7 text-large-x leading-22 text-danger font-semibold">¥ {{ totalPrice }}</div>
            </div>
          </div>
        </div>
      </section>
    </el-scrollbar>
    <footer
      class="w-full h-14 px-4 box-border absolute bottom-0 right-0 bg-white shadow-theme flex items-center justify-end"
      style="z-index: 1002"
      v-show="showFooter"
    >
      <div class="flex items-center mr-14">
        <p class="text-medium text-theme-black-850 leading-22">预估样本单价</p>
        <el-tooltip content="预估样本单价为无配额要求时报价，如需指定配额，请联系客服获取详细报价" placement="top">
          <i class="iconfont icon-shuoming text-theme-black-350 ml-1 text-medium-x"></i>
        </el-tooltip>
        <div class="ml-3 text-large-x text-danger leading-22 font-semibold">¥ {{ samplePrice }}</div>
      </div>
      <div class="flex items-center mr-6">
        <p class="text-medium text-theme-black-850 leading-22">需要样本数量</p>
        <input-field-number
          class="ml-4 field-num-left scale-field"
          :min="50"
          :max="10000000"
          :precision="0"
          v-model="sampleNum"
          size="small"
          controls-position="right"
        />
      </div>
      <div class="flex items-center">
        <p class="text-medium text-theme-black-850 leading-22">本次预估报价</p>
        <el-tooltip content="仅为预估报价，实际报价请扫码咨询获取，还有更多优惠" placement="top">
          <i class="iconfont icon-shuoming text-theme-black-350 ml-1 text-medium-x"></i>
        </el-tooltip>
        <div class="ml-3 text-large-x text-danger leading-22 font-semibold">¥ {{ totalPrice }}</div>
      </div>
    </footer>
  </div>
</template>

<script>
import SampleServiceCheck from './SampleServiceCheck'
import { checkGroupList } from '../config/sample-service'
import InputFieldNumber from '@/components/base/InputFieldNumber'

export default {
  name: 'AutoService',
  components: {
    InputFieldNumber,
    SampleServiceCheck,
  },
  data() {
    return {
      checkGroupList,
      wjQusNum: 20,
      sampleNum: 200,
      groupValues: {
        sex: '',
        area: [],
        marriage: '',
        age: [],
        industry: [],
        jobExp: [],
        wages: [],
        job: [],
        degree: [],
        specificThrong: ''
      },
      showFooter: true
    }
  },
  computed: {
    groupPrice() {
      const price = {}
      for (const key in this.groupValues) {
        const value = this.groupValues[key]
        if (Array.isArray(value)) {
          const pVal = value.length === 0 ? '' : Math.min(...value.map(m => JSON.parse(m)[0]))
          price[key] = pVal === '' ? pVal : `￥${(+pVal).toFixed(2)}`
        } else {
          const pVal = value ? JSON.parse(value)[0] : ''
          price[key] = pVal === '' ? pVal : `￥${(+pVal).toFixed(2)}`
        }
      }
      return price
    },
    wjUnitPrice() {
      if (this.wjQusNum <= 20) {
        return (1.8).toFixed(2)
      } else if (this.wjQusNum >= 21 && this.wjQusNum <= 300) {
        const offset = this.wjQusNum >= 21 && this.wjQusNum <= 70 ? 0.5 : 0
        const dropDiff = this.wjQusNum % 10 === 0 ? -1 : 0
        const num = Math.floor(this.wjQusNum / 10)
        return (num + dropDiff + offset).toFixed(2)
      }
      return '0.00'
    },
    samplePrice() {
      const count = Object.values(this.groupPrice)
        .map(m => (m ? parseFloat(m.replace('￥', '')) : 0))
        .reduce((a, b) => a + b, 0)
      return (count + parseFloat(this.wjUnitPrice)).toFixed(2)
    },
    totalPrice() {
      const bTotal = parseInt(this.samplePrice * this.sampleNum * 100)
      return (bTotal / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    scrollContainer() {
      return this.$refs.scrollRef.wrap
    }
  },
  created() {
    // 防止滑块显示气泡的同时滑动界面 导致最外层内容溢出出现滚动条
    document.documentElement.classList.add('overflow-hidden')
  },
  mounted() {
    if (this.scrollContainer) {
      this.scrollContainer.addEventListener('scroll', this.executeScrollContainer)
      setTimeout(() => {
        this.resizeScreen()
      }, 100)
    }
    window.addEventListener('resize', this.resizeScreen)
  },
  beforeDestroy() {
    document.documentElement.classList.remove('overflow-hidden')
    if (this.scrollContainer) {
      this.scrollContainer.removeEventListener('scroll', this.executeScrollContainer)
    }
    window.removeEventListener('resize', this.resizeScreen)
  },
  methods: {
    numberBlur(e) {
      this.wjQusNum = e.target.value
    },
    resizeScreen() {
      if (this.scrollContainer) {
        const { scrollHeight, clientHeight, scrollTop } = this.scrollContainer
        this.executeScrollContainer({
          target: {
            scrollHeight,
            clientHeight,
            scrollTop
          }
        })
      }
    },
    executeScrollContainer(e) {
      const { scrollHeight, clientHeight, scrollTop } = e.target
      if (scrollHeight - clientHeight - scrollTop <= 100) {
        if (this.showFooter) {
          this.showFooter = false
        }
      } else {
        if (!this.showFooter) {
          this.showFooter = true
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.w-80px {
  width: 80px;
}
.w-230px {
  width: 230px;
}
.w-110px {
  width: 110px;
}
.sub-words {
  line-height: 38px;
  @apply pl-4 text-theme-black-650 text-medium bg-theme-100;
}
.wj-calc-label {
  @apply pr-4 py-4 box-border flex justify-end items-center whitespace-nowrap text-theme-black-450 text-medium font-semibold;
  min-width: 90px;
}
.calc-slider {
  ::v-deep .el-slider__button {
    width: 10px;
    height: 10px;
  }
}
.field-num-left {
  ::v-deep input {
    text-align: left;
  }
}
.scale-field {
  width: 110px;
  height: 32px;
  transform: scale(0.8);
  transform-origin: 0;
}
</style>
